const v6 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        videosTable: {
          Published: true,
          Views: true,
          V7: false,
          V30: false,
          VPH7: false,
          VPH30: false,
          "V7 Index": false,
          "V30 Index": false,
          Revenue: false,
          RPM: false,
          R7: false,
          R30: false,
          "R7 Index": false,
          "R30 Index": false,
          "Script topics": true,
          "Thumb topics": true,
          "Title topics": true,
          "Video type": true,
        },
      },
    },
  };
};

export default v6;
